import { render, staticRenderFns } from "./addCoApplicantV2.vue?vue&type=template&id=f67741a2"
import script from "./addCoApplicantV2.vue?vue&type=script&lang=js"
export * from "./addCoApplicantV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports